// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRelay = require("react-relay");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");

function makeRefetchVariables() {
  
}

var Types = {
  makeRefetchVariables: makeRefetchVariables
};

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"currentlyLoggedInAgent":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

var responseConverter = {"__root":{"currentlyLoggedInAgent":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfilePageRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Agent",
        "kind": "LinkedField",
        "name": "currentlyLoggedInAgent",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfilePagePersonalInformationForm_agent"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SharingProfileMiniFormProfilePhoto_agent"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfilePageAddressInformationForm_agent"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfilePageBiographyInformationForm_agent"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfilePageSocialMediaForm_agent"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfilePageProfilePhotoForm_agent"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "ProfilePageRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Agent",
        "kind": "LinkedField",
        "name": "currentlyLoggedInAgent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brokerage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "website",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userEnteredDisplayName",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfilePhoto",
            "kind": "LinkedField",
            "name": "profilePhoto",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 60
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": "photoUrl",
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 96
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "membershipStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentAddressInfo",
            "kind": "LinkedField",
            "name": "addressInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stateAbbr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "streetAddress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zip",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "biography",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentSocialMediaAccounts",
            "kind": "LinkedField",
            "name": "socialMedia",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "facebookHandle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "instagramHandle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "linkedInHandle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "twitterHandle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "yelpHandle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "youTubeHandle",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3f5ade2efabca250d1fd15acd58e40c7",
    "id": null,
    "metadata": {},
    "name": "ProfilePageRelayQuery",
    "operationKind": "query",
    "text": "query ProfilePageRelayQuery(\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  currentlyLoggedInAgent {\n    ...ProfilePagePersonalInformationForm_agent\n    ...SharingProfileMiniFormProfilePhoto_agent\n    ...ProfilePageAddressInformationForm_agent\n    ...ProfilePageBiographyInformationForm_agent\n    ...ProfilePageSocialMediaForm_agent\n    ...ProfilePageProfilePhotoForm_agent\n    nodeId\n  }\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n  membershipStatus\n}\n\nfragment ProfilePageAddressInformationForm_agent on Agent {\n  addressInfo {\n    city\n    stateAbbr\n    streetAddress\n    zip\n  }\n}\n\nfragment ProfilePageBiographyInformationForm_agent on Agent {\n  biography\n}\n\nfragment ProfilePagePersonalInformationForm_agent on Agent {\n  firstName\n  lastName\n  brokerage\n  phone\n  emailAddress\n  website\n  userEnteredDisplayName\n  ...AgentInfo_agent\n}\n\nfragment ProfilePageProfilePhotoForm_agent on Agent {\n  ...SharingProfileMiniFormProfilePhoto_agent\n}\n\nfragment ProfilePageSocialMediaForm_agent on Agent {\n  id\n  socialMedia {\n    facebookHandle\n    instagramHandle\n    linkedInHandle\n    twitterHandle\n    yelpHandle\n    youTubeHandle\n  }\n}\n\nfragment SharingProfileMiniFormProfilePhoto_agent on Agent {\n  firstName\n  displayName\n  ...SharingProfileMiniFormProfilePhoto_currentPhoto_agent\n  ...SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent\n}\n\nfragment SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent on Agent {\n  id\n  profilePhoto {\n    __typename\n  }\n}\n\nfragment SharingProfileMiniFormProfilePhoto_currentPhoto_agent on Agent {\n  profilePhoto {\n    photoUrl: url(width: 96, ratio: $__relay_internal__pv__DevicePixelRatio)\n    id\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

var node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
              fetchKey: fetchKey,
              fetchPolicy: fetchPolicy,
              networkCacheConfig: networkCacheConfig
            });
}

function queryRefToObservable(token) {
  return Caml_option.nullable_to_opt(token.source);
}

function queryRefToPromise(token) {
  return new Promise((function (resolve, param) {
                var o = queryRefToObservable(token);
                if (o !== undefined) {
                  Caml_option.valFromOption(o).subscribe({
                        complete: (function () {
                            resolve({
                                  TAG: "Ok",
                                  _0: undefined
                                });
                          })
                      });
                  return ;
                } else {
                  return resolve({
                              TAG: "Error",
                              _0: undefined
                            });
                }
              }));
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
